import { startTransition, useEffect } from "react";

import { renderEditedImage } from "../lib/image-processing";
import { useHorizonStore } from "../store/useHorizonStore";

export function useRenderedImage(): void {
  const originalImage = useHorizonStore((state) => state.originalImage);
  const editorState = useHorizonStore((state) => state.editorState);
  const setRenderedImage = useHorizonStore((state) => state.setRenderedImage);
  const setRenderStatus = useHorizonStore((state) => state.setRenderStatus);

  useEffect(() => {
    if (!originalImage) {
      setRenderedImage(null);
      setRenderStatus("idle", null);
      return;
    }

    let cancelled = false;
    const timeout = window.setTimeout(() => {
      void (async () => {
        setRenderStatus("loading", null);
        try {
          const rendered = await renderEditedImage(originalImage.objectUrl, editorState);
          if (cancelled) {
            URL.revokeObjectURL(rendered.objectUrl);
            return;
          }
          startTransition(() => {
            setRenderedImage(rendered);
            setRenderStatus("success", null);
          });
        } catch (error) {
          if (!cancelled) {
            setRenderStatus("error", error instanceof Error ? error.message : "Failed to render preview.");
          }
        }
      })();
    }, 120);

    return () => {
      cancelled = true;
      window.clearTimeout(timeout);
    };
  }, [
    editorState.aspectPreset,
    editorState.blur,
    editorState.brightness,
    editorState.contrast,
    editorState.crop.x,
    editorState.crop.y,
    editorState.cropAreaPixels?.height,
    editorState.cropAreaPixels?.width,
    editorState.cropAreaPixels?.x,
    editorState.cropAreaPixels?.y,
    editorState.flipHorizontal,
    editorState.flipVertical,
    editorState.rotation,
    editorState.saturation,
    editorState.sharpen,
    editorState.zoom,
    originalImage,
    setRenderedImage,
    setRenderStatus
  ]);
}
